import { createApp } from 'vue'
import App from './App.vue'

// eslint-disable-next-line
import './styles.css';
createApp(App).mount('#app')
